export function isObject<T = Record<string, unknown>>(obj: unknown): obj is Record<keyof T, unknown> {
  if (!obj) return false;
  return typeof obj === 'object';
}
